import './barChart.css';

import { useEffect, useState, useMemo } from 'react';

import { BarChart, Bar, CartesianGrid, XAxis, YAxis, ReferenceLine, Cell, Legend, Tooltip } from "recharts";

export default function BarChartComponent({analyticsTime,filteredCategories}) {

    return(
        <div className="bar-chart card">
            <BarChart width={300} height={300} data={filteredCategories[analyticsTime]} className="chart" margin={{ top: 10, right: 10, bottom: 10, left: -18 }}>
                <Bar dataKey='expense_amount'>
                    {filteredCategories[analyticsTime].map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.expense_svg_color} />
                    ))}
                </Bar>
                
                <CartesianGrid strokeDasharray={'5 5'}/>
                <XAxis dataKey='expense_name' hide/>
                <YAxis/>
                <Tooltip/>

                {/*<ReferenceLine 
                    y={100}                     
                    stroke="red"                    
                    strokeDasharray="3 3"            
                    label={{ value: 'Budget Limit', fill: 'red', position: 'top' }}
                />*/}

            </BarChart> 
        </div>
    )
}